/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	compactControl: {
		width: '12.5rem',
		maxWidth: '100%',
	},
	compactValueControl: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
		height: '2.5rem',
		minWidth: '0',
		paddingInline: token('space.100'),
		borderRadius: token('radius.small'),
		overflow: 'hidden',
		'&:hover': {
			backgroundColor: token('color.background.neutral.subtle.hovered'),
		},
	},
	compactValueControlDisabled: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
		height: '2.5rem',
		minWidth: '0',
		paddingInline: token('space.100'),
		borderRadius: token('radius.small'),
		overflow: 'hidden',
	},
});

export const CompactDetailValue = ({
	children,
	appearance = 'value',
	isDisabled = false,
}: {
	children: ReactNode;
	appearance?: 'control' | 'value';
	isDisabled?: boolean;
}): JSX.Element => (
	<Box xcss={styles.compactControl}>
		{appearance === 'control' ? (
			children
		) : (
			<Box xcss={isDisabled ? styles.compactValueControlDisabled : styles.compactValueControl}>
				{children}
			</Box>
		)}
	</Box>
);
